export const POLICY_TYPES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  AMEND_REMOVE_SECONDARY: 'amend_remove_secondary',
  AMEND_REMOVE_PRIMARY: 'amend_remove_primary',
  AMEND_ADD_PRIMARY: 'amend_add_primary',
  AMEND_ADD_SECONDARY: 'amend_add_secondary',
  AMEND_REMOVE_ADDED: 'amend_remove_added',
};

export const POLICY_STATUS = {
  ABANDONED: 'Abandoned',
  AGENCY_DECLINED_E_SUBMIT: 'Agency Declined to e-Submit',
  E_SUBMITTED: 'Application e-Submitted',
  AWAITING_APPROVAL: 'Awaiting Agency Approval',
  AWAITING_AGENT_SIGNATURE: 'Awaiting Agent e-Signature',
  AWAITING_CONSUMER_SIGNATURE: 'Awaiting Consumer Signature',
  CONSUMER_DECLINED: 'Consumer Declined to e-Sign',
  LINK_EXPIRED: 'e-Signature Link Expired',
  E_SUBMITTED_WET: 'e-Submitted with Wet Signatures',
  E_SUBMITTED_ACK: 'e-Submitted - Confirm. Sent',
  PRINT_TO_SIGN: 'Print for Wet Signatures',
  STARTED: 'Started',
  SYNC_TO_SUBMIT: 'Sync to e-Submit',
  PENDING_APPROVAL: 'Pending Principal Agent Approval',
  DECLINED: 'Declined by Principal Agent',
};

export const POLICY_UW_TYPES = {
  AU: { code: 'Accelerated', desc: 'Accelerated' },
  Algo: { code: 'Algorithmic', desc: 'Algorithmic' },
  Manual: { code: 'Manual', desc: 'Manual' },
};

export const POLICY_DOC_ANNUITY_DOCTYPES = {
  annuityApplication: 'AnnuityApplication',
  annuitySuitabilityForm: 'AnnuitySuitabilityForm',
  annuityReplacementForm: 'AnnuityReplacementForm',
  annuityProductDisclosure: 'AnnuityProductDisclosure',
  annuityIDVerificationConsent: 'AnnuityIDVerificationConsentForm',
  annuityProductSnapshot: 'AnnuityProductSnapshot',
  annuityPrivacyPolicy: 'AnnuityPrivacyPolicy',
  annuityRECEConsent: 'AnnuityRECEConsent',
  annuityIllustration: 'AnnuityIllustration',
  annuityBuyerGuide: 'AnnuityBuyerGuide',
  annuityStateSupplemental: 'AnnuityStateSupplemental',
  annuityADARForm: 'AnnuityADARForm',
};

export const POLICY_DOC_DOCTYPES = {
  aps: 'APS',
  amendment: 'Amendment',
  rx: 'Rx',
  lab: 'Lab results',
  eir: 'EIR',
  taxForm: 'Tax Form',
  financialForm: 'Financial Form',
  visa: 'Visa/Green card',
  i797: 'I-797',
  archive: 'Archive',
  other: 'Other',
  RevisedBasicIllustration: 'RevisedBasicIllustration',
  basicIllustration: 'BasicIllustration',
  mec: 'Mec',
  ...POLICY_DOC_ANNUITY_DOCTYPES,
};

/**
 * Use 0.08333333333 (instead of 1/12) for this ratio,
 * because 0.08333333333 factor is used by product and policy admin.
 * https://massmutual.atlassian.net/browse/HL-10302
 */
export const YEARLY_TO_MONTHLY_RATIO = 0.08333333333;

// exchange1035
export const EXPECTED_ARRIVAL_DEFAULT_MONTHS: number = 3;

export const defaultTaxBracket = 32;

export type TERM_PRODUCT_CODE = 'CASTerm' | 'CASTermECP' | 'MMDirectTerm' | 'MMDirectTermECP';
export type WHOLE_LIFE_PRODUCT_CODE =
  | 'CPL100'
  | 'CPL100A'
  | 'CPL65'
  | 'CPL65A'
  | 'CPL10'
  | 'CPL10A'
  | 'CPL12'
  | 'CPL15'
  | 'CPL15A'
  | 'CPL20'
  | 'CPL20A';
export type HEALTH_CLASS = 'ULTRA' | 'SELECT' | 'STANDARD' | 'SELECT_TOBACCO' | 'STANDARD_TOBACCO';
export type DIVIDEND_OPTION = 'PUA' | 'Cash' | 'PRPUA' | 'PRCash' | 'Accumulate';
